import { useRef, useState } from "react";
import { isMediumDeviceAndUp } from "common/utils/browser";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import Tooltip from "common/vue/components/Tooltip.react.vue";
import CommonModal from "common/vue/components/CommonModal.react.vue";
// eslint-disable-next-line import/no-cycle
import MockupDisplay from "./MockupDisplay.vue";
import { useDtfStore } from "../store";
import "./MockupButton.scss";

function MockupButton({ index, ...restProps }) {
  const [isOpenMockupModal, setIsOpenMockupModal] = useState(false);
  const mockupModalRef = useRef(null);
  const mockupTooltipRef = useRef(null);
  const isMobile = !isMediumDeviceAndUp();
  const store = useDtfStore();

  function artwork() {
    return store.artworks[index];
  }

  function openMockupModal() {
    submitDtfEvent("preset_mockup_modal_opened", {
      artwork_id: artwork().id
    });
    if (isMobile) {
      setIsOpenMockupModal(true);
    }
  }

  function closeMockupModal() {
    mockupModalRef.current?.close();
    setIsOpenMockupModal(false);
  }

  function closeMockupTooltip() {
    mockupTooltipRef.current?.hideTooltip();
  }

  return (
    <>
      <Tooltip
        ref={mockupTooltipRef}
        disabled={isMobile}
        trigger="click"
        customPosition={{
          top: "-60%",
          left: "100%",
          transform: "translateX(-100%)"
        }}
        slots={{
          target: () => (
            <button
              className="mockup-button__mockups-link"
              type="button"
              onClick={openMockupModal}
              data-testid="mockup-button-mockups-link"
            >
              {" "}
              View Larger Mockups{" "}
            </button>
          ),

          content: () => (
            <MockupDisplay
              artworkUrl={artwork().url}
              index={index}
              size="large"
              onClose={closeMockupTooltip}
              data-testid="mockup-display"
            />
          )
        }}
        data-testid="tooltip"
      />

      {isMobile && isOpenMockupModal ? (
        <CommonModal
          ref={mockupModalRef}
          compact={true}
          hideCloseButton={true}
          bottomAligned={true}
          data-testid="common-modal"
        >
          <MockupDisplay
            isMobile={true}
            artworkUrl={artwork().url}
            size="medium"
            onClose={closeMockupModal}
            data-testid="mockup-display-1"
          />
        </CommonModal>
      ) : null}
    </>
  );
}

export default MockupButton;
